import { useEffect, useRef } from "react";
import { attachFxCanvas } from "./fx.ts";

/** Full-screen, click-through canvas for celebration particles. */
export function FxLayer() {
  const ref = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    attachFxCanvas(ref.current);
    return () => attachFxCanvas(null);
  }, []);
  return <canvas ref={ref} className="fx-layer" aria-hidden="true" />;
}
